import { render, staticRenderFns } from "./Sectors.vue?vue&type=template&id=5e3b4118&"
import script from "./Sectors.vue?vue&type=script&lang=js&"
export * from "./Sectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports